import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Pre-rendered HTML (see scripts/prerender.js) ships per-page <title>/<meta>/JSON-LD
// in <head> for crawlers. Strip them before React 19 hoists fresh ones, so browsers
// never end up with duplicate SEO tags.
const STALE_HEAD_SELECTORS = [
  "title",
  'meta[name="description"]',
  'meta[name="keywords"]',
  'meta[name="robots"]',
  'meta[property^="og:"]',
  'meta[name^="twitter:"]',
  'meta[name^="geo."]',
  'meta[name="ICBM"]',
  'meta[name="format-detection"]',
  'link[rel="canonical"]',
  'script[type="application/ld+json"]',
].join(",");
document.head.querySelectorAll(STALE_HEAD_SELECTORS).forEach((el) => el.remove());

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
